import PageHelper from './page-helper';

const LoaderTemplate = '<div class="loading-indicator"></div>';

export default class FormSubmitHelper {

  static BUTTON_CONTAINER_CLASS = '.js-disableMultipleSubmitButton';
  static FORM_CONTAINER_CLASS = '.js-submitFormControl';
  static FORM_ENABLE_SUBMIT_ONVALID = '.js-enableSubmitOnValid';

  static initForm(form: JQuery): void {
    form.on('submit', (e) => {
      this.showLoader($(e.currentTarget) as JQuery<HTMLFormElement>);
    });
  }

  static showLoader(form: JQuery<HTMLFormElement>): void {
    if (form.data('parsley-validate') && !form.parsley().isValid()) {
      return;
    }

    if (form.data('loader-fullpage')) {
      PageHelper.showLoadingIndicator();
    } else if (form.data('loader-container')) {
      const loadingIndicator = form.closest(form.data('loader-container'));
      loadingIndicator.append(LoaderTemplate);
    } else {
      form.append(LoaderTemplate);
    }
  }

  static bindSubmitToValidation(submit: JQuery<HTMLButtonElement>): void {
    if (!submit[0]?.form) {
      return;
    }
    const form = $(submit[0].form);
    submit.prop('disabled', !form.parsley().isValid());
    form.find('input').on('input', () => {
      submit.prop('disabled', !form.parsley().isValid());
    });
  }

  static initAll(): void {
    FormSubmitHelper.initForm($(FormSubmitHelper.FORM_CONTAINER_CLASS));
    FormSubmitHelper.bindSubmitToValidation($(FormSubmitHelper.FORM_ENABLE_SUBMIT_ONVALID));
  }
}
